module.exports = __webpack_public_path__ + "media/images/shadow-9d02683728ba356c39b5d122dfb91fe0.svg";